export const COOKIE_BANNER_ID = 'cookie-banner-dialog';
export const COOKIE_CONSENT = 'cookie_consent';

// Dispatched on window right after the consent cookie is written (accept or
// decline alike), so anything waiting for the banner to be answered in this
// page view can react without being wired through the component tree.
export const COOKIE_CONSENT_DECIDED_EVENT = 'cookieconsentdecided';

// Cookie expiry (days)
export const OPTIONAL_COOKIES_EXPIRY = 365;
export const DECLINE_OPTIONAL_COOKIES_EXPIRY = 30;
export const MARKET_COOKIE_EXPIRY = 30;
export const REDIRECT_COOKIE_EXPIRY = 30;
